document.addEventListener('DOMContentLoaded', function () {
    // ===== BLOG SWIPER =====
    let blogSwiper = null;

    function createBlogSwiper() {
        blogSwiper = new Swiper('.swiper-pdp-blog', {
            slidesPerView: 'auto',
            loop: false,
            spaceBetween: 10,
            centeredSlides: false,
            pagination: {
                el: '#swiper-pagination-blog-styling',
                type: 'progressbar',
                clickable: true,
            },
            breakpoints: {
                769: {
                    slidesPerView: 'auto',
                    loop: false,
                    spaceBetween: 10,
                    centeredSlides: false,
                    pagination: {
                        el: '#swiper-pagination-blog-styling',
                        type: 'progressbar',
                        clickable: true,
                    },
                }
            }
        });
    }

    function destroyBlogSwiper() {
        if (blogSwiper !== null) {
            blogSwiper.destroy();
            blogSwiper = null;
        }
    }

    function handleBlogSwiper() {
        if (window.innerWidth < 769) {
            if (blogSwiper === null) {
                createBlogSwiper();
            }
        } else {
            destroyBlogSwiper();
        }
    }

    // ===== WHY VITAL SWIPER =====
    let whyVitalSwiper = null;

    function createWhyVitalSwiper() {
        whyVitalSwiper = new Swiper('.swiper-why-vital', {
            slidesPerView: 'auto',
            loop: false,
            spaceBetween: 10,
            paginationClickable: true,
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination-why-vital',
                clickable: true,
            },
            breakpoints: {
                966: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    centeredSlides: true,
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination-why-vital',
                        clickable: true,
                    }
                }
            }
        });
    }

    function destroyWhyVitalSwiper() {
        if (whyVitalSwiper !== null) {
            whyVitalSwiper.destroy();
            whyVitalSwiper = null;
        }
    }

    function handleWhyVitalSwiper() {
        if (window.innerWidth < 966) {
            if (whyVitalSwiper === null) {
                createWhyVitalSwiper();
            }
        } else {
            destroyWhyVitalSwiper();
        }
    }

    // ===== TESTIMONIALS SWIPER =====
    let testimonialsSwiper = null;

    function createTestimonialsSwiper() {
        testimonialsSwiper = new Swiper('.swiper-pdp-testimonials', {
            slidesPerView: 1.3,
            loop: false,
            centeredSlides: true,
            spaceBetween: 10,
            pagination: {
                el: '#swiper-pagination-testimonials-styling',
                type: 'progressbar',
                clickable: true,
            },
            breakpoints: {
                769: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    centeredSlides: true,
                    loop: false,
                }
            }
        });
    }

    function destroyTestimonialsSwiper() {
        if (testimonialsSwiper !== null) {
            testimonialsSwiper.destroy();
            testimonialsSwiper = null;
        }
    }

    function handleTestimonialsSwiper() {
        if (window.innerWidth < 769) {
            if (testimonialsSwiper === null) {
                createTestimonialsSwiper();
            }
        } else {
            destroyTestimonialsSwiper();
        }
    }

    // ===== INITIALIZE ALL SWIPERS =====
    function handleAllSwipers() {
        handleBlogSwiper();
        handleWhyVitalSwiper();
        handleTestimonialsSwiper();
    }

    handleAllSwipers();

    window.addEventListener('resize', function () {
        handleAllSwipers();
    });

  
});



    if(!window.CarouselManager){
    const CarouselManager = ({random, perView, behavior, focusAt, bound}) => {
      let carousel;
      const carouselItemWidth = 302; //px
      const slides = document.querySelectorAll(`.product-card-carousel-${random}-slide.visible`).length;

      const handle = () => {
        if(window.innerWidth/carouselItemWidth < slides) {
          if(!carousel){
            if(window.innerWidth < 1024){
              document.getElementsByClassName(`product-card-carousel-${random}-controls`)[0].style.display = 'none';
            } else{
              document.getElementsByClassName(`product-card-carousel-${random}-controls`)[0].style.display = '';
            }
            const hasDots = null;
            const carouselConfig = {
                slidesPerView: 'auto',
              ...behavior === 'carousel' && {
                loop: true,
              },
              ...hasDots && {
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
              },
              navigation: {
                nextEl: `.product-card-carousel-${random} #next`,
                prevEl: `.product-card-carousel-${random} #prev`,
              },
              centeredSlides: perView === 0,
            }
            carousel = new Swiper(`.product-card-carousel-${random}`, carouselConfig);
          }
        }else{
          if(carousel){
            carousel.destroy(true, true);
            carousel = undefined;
          }
          let el = document.getElementsByClassName(`product-card-carousel-${random}-controls`);
          if(el && el.length > 0){
            el[0].style.display = 'none';
          }
        }
      }
      const listenWindowResizes = () => {
        window.addEventListener('resize', handle);
      }
      return {handle, listenWindowResizes}
    }
    window.CarouselManager = CarouselManager;
  }
  document.addEventListener("DOMContentLoaded", function() {
      (function(){
        const managerProps = {
          random: "",
          perView: 0,
          behavior: "carousel",
          focusAt: "center",
          bound: false
        };
        const findSwiper = setInterval(()=>{
          if(typeof Swiper !== 'undefined'){
            clearInterval(findSwiper);
            const carouselManager = CarouselManager(managerProps);
            carouselManager.handle();
            carouselManager.listenWindowResizes();
          }
        }, 500);
      }());
    })